import React from "react";

import Navbar3 from "../Components/Navbar3";
import Footer from "../Components/Footer";

function PrivacyPolicy() {
  return (
    <>
      <Navbar3 />

      <main className="terms-page">
        <div className="container">
          <div className="terms-content">

            <h1 className="futuraPTMedium">
              Privacy Policy
            </h1>

            <p className="terms-effective-date">
              <strong>Effective Date:</strong> August 20, 2026
              <br />
              <strong>Last Updated:</strong> August 20, 2026
            </p>

            <p>
              <strong>ADS Sports Complex, LLC</strong>, doing business
              as <strong>ADS Sports Complex</strong> ("ADS Sports
              Complex," "we," "us," or "our"), respects your privacy.
            </p>

            <p>
              This Privacy Policy describes how we collect, use,
              disclose, retain, and protect information when you
              interact with ADS Sports Complex, including through our
              website, applications, facilities, products, services,
              ordering systems, reservations, events, account
              services, and SMS text messaging program.
            </p>

            <h2 className="futuraPTMedium">
              1. Information We Collect
            </h2>

            <p>
              Depending on how you interact with ADS Sports Complex,
              we may collect the following categories of information.
            </p>

            <h3>Account and Contact Information</h3>

            <p>
              We may collect information such as:
            </p>

            <ul>
              <li>Name</li>
              <li>Email address</li>
              <li>Mobile telephone number</li>
              <li>Mailing address</li>
              <li>Billing address</li>
              <li>Account username or identifier</li>
              <li>Account preferences</li>
              <li>Communication preferences</li>
            </ul>

            <h3>Order Information</h3>

            <p>
              When you place, receive, or otherwise interact with an
              order, we may collect:
            </p>

            <ul>
              <li>Order number</li>
              <li>Products or services ordered</li>
              <li>Order date and time</li>
              <li>Order status</li>
              <li>Pickup information</li>
              <li>Delivery information</li>
              <li>Special instructions</li>
              <li>Fulfillment details</li>
              <li>Payment transaction information</li>
              <li>
                Other information necessary to process or fulfill an
                order
              </li>
            </ul>

            <p>
              Payment card information may be processed by third-party
              payment service providers rather than stored directly
              by ADS Sports Complex.
            </p>

            <h3>Reservation and Event Information</h3>

            <p>
              When you make, manage, or participate in a reservation
              or event, we may collect:
            </p>

            <ul>
              <li>Reservation number</li>
              <li>Reservation type</li>
              <li>
                Facility, field, court, room, or event information
              </li>
              <li>Reservation date and time</li>
              <li>Participants or authorized contacts</li>
              <li>Reservation status</li>
              <li>Schedule changes</li>
              <li>Cancellation information</li>
              <li>
                Other details necessary to administer the reservation
                or event
              </li>
            </ul>

            <h3>Authentication and Security Information</h3>

            <p>
              We may collect or generate information used to protect
              accounts and verify identities, including:
            </p>

            <ul>
              <li>Mobile telephone number</li>
              <li>Authentication attempts</li>
              <li>One-time passcodes</li>
              <li>Multi-factor authentication status</li>
              <li>Login activity</li>
              <li>Device information</li>
              <li>Security event information</li>
              <li>
                Other information used to detect or prevent
                unauthorized access
              </li>
            </ul>

            <p>
              Verification codes are intended for temporary use and
              should not be shared with another person.
            </p>

            <h3>SMS Messaging Information</h3>

            <p>
              If you participate in our SMS messaging program, we may
              collect and maintain information such as:
            </p>

            <ul>
              <li>Your mobile telephone number</li>
              <li>Date and time of consent</li>
              <li>Method through which consent was obtained</li>
              <li>Types of messages you elected to receive</li>
              <li>Messages sent to you</li>
              <li>Message timestamps</li>
              <li>Delivery status</li>
              <li>Opt-in status</li>
              <li>Opt-out status</li>
              <li>Re-opt-in status</li>
              <li>STOP requests</li>
              <li>HELP requests</li>
              <li>Other SMS-related communications</li>
              <li>
                Information necessary to operate, administer, secure,
                and document the messaging program
              </li>
            </ul>

            <h3>Employee Information</h3>

            <p>
              For authorized employees receiving internal operational
              notifications, we may process:
            </p>

            <ul>
              <li>Employee name</li>
              <li>Employee identifier</li>
              <li>Employee telephone number</li>
              <li>Role or work assignment</li>
              <li>Order information</li>
              <li>Reservation information</li>
              <li>Operational communications</li>
              <li>
                Delivery status of business-related messages
              </li>
            </ul>

            <h2 className="futuraPTMedium">
              2. How We Use Information
            </h2>

            <p>
              ADS Sports Complex may use information we collect to:
            </p>

            <ul>
              <li>Create and administer accounts</li>
              <li>Authenticate users</li>
              <li>Provide one-time passcodes</li>
              <li>Provide multi-factor authentication</li>
              <li>Protect accounts and systems</li>
              <li>Process and fulfill orders</li>
              <li>Provide order status notifications</li>
              <li>Provide pickup and delivery notifications</li>
              <li>Create and administer reservations</li>
              <li>Provide reservation notifications</li>
              <li>Provide event updates</li>
              <li>
                Notify customers of cancellations or schedule changes
              </li>
              <li>
                Coordinate order fulfillment with authorized
                employees
              </li>
              <li>Coordinate reservations and events</li>
              <li>Provide customer support</li>
              <li>Maintain security</li>
              <li>
                Detect, investigate, and prevent fraud or unauthorized
                activity
              </li>
              <li>Maintain records of SMS consent</li>
              <li>Process opt-out requests</li>
              <li>Respond to HELP requests</li>
              <li>Maintain operational and transaction records</li>
              <li>Improve our services</li>
              <li>Comply with applicable laws and regulations</li>
              <li>Enforce agreements and policies</li>
              <li>
                Protect ADS Sports Complex, our customers, employees,
                systems, and property
              </li>
            </ul>

            <h2 className="futuraPTMedium">
              3. SMS Messaging and Consent
            </h2>

            <p>
              ADS Sports Complex may use your mobile telephone number
              to send transactional, informational, security-related,
              or operational SMS messages.
            </p>

            <p>
              These messages may include:
            </p>

            <ul>
              <li>Multi-factor authentication codes</li>
              <li>One-time verification codes</li>
              <li>Account security notifications</li>
              <li>Order status updates</li>
              <li>Order preparation notifications</li>
              <li>Pickup notifications</li>
              <li>Delivery notifications</li>
              <li>Reservation notifications</li>
              <li>Event updates</li>
              <li>Schedule changes</li>
              <li>Reservation cancellations</li>
              <li>Event cancellations</li>
            </ul>

            <p>
              Optional order, reservation, and event notification
              messages are sent only when you have elected to receive
              those notifications.
            </p>

            <p>
              Message frequency varies.
            </p>

            <p>
              Message and data rates may apply.
            </p>

            <p>
              You may opt out of applicable SMS messages at any time
              by replying:
            </p>

            <div className="terms-sms-command">
              STOP
            </div>

            <p>
              to a message from ADS Sports Complex.
            </p>

            <p>
              After you send STOP, you may receive a final
              confirmation message confirming that your opt-out
              request has been processed.
            </p>

            <p>
              ADS Sports Complex does not currently provide a website
              or account-based interface for managing SMS preferences.
              To opt out of SMS messages, reply <strong>STOP</strong>{" "}
              to a message from ADS Sports Complex.
            </p>

            <p>
              For assistance, reply:
            </p>

            <div className="terms-sms-command">
              HELP
            </div>

            <p>
              to a message from ADS Sports Complex.
            </p>

            <p>
              Our Terms and Conditions are available at:
            </p>

            <p>
              <a href="/TermsConditions">
                https://adssportscomplex.com/TermsConditions
              </a>
            </p>

            <h2 className="futuraPTMedium">
              4. SMS Consent and Mobile Information
            </h2>

            <p>
              ADS Sports Complex does not sell your mobile telephone
              number, SMS opt-in information, or SMS consent
              information.
            </p>

            <p>
              We do not share SMS opt-in information or consent with
              third parties or affiliates for their own marketing or
              promotional purposes.
            </p>

            <p>
              We may disclose mobile telephone numbers and related SMS
              information to vendors and service providers that assist
              us in delivering, operating, securing, or administering
              our messaging program.
            </p>

            <p>
              These providers may include:
            </p>

            <ul>
              <li>SMS messaging providers</li>
              <li>Telecommunications providers</li>
              <li>Wireless carriers</li>
              <li>Cloud hosting providers</li>
              <li>Authentication providers</li>
              <li>Information-security providers</li>
            </ul>

            <p>
              Such disclosures are made only as reasonably necessary
              to provide, maintain, secure, administer, or support our
              services.
            </p>

            <h2 className="futuraPTMedium">
              5. Twilio and Other Messaging Service Providers
            </h2>

            <p>
              ADS Sports Complex may use <strong>Twilio Inc.</strong>{" "}
              or other communications service providers to facilitate
              SMS delivery.
            </p>

            <p>
              When we send or receive SMS communications, information
              necessary to transmit and manage those communications
              may be processed by the applicable messaging provider,
              telecommunications providers, and wireless carriers.
            </p>

            <p>
              This information may include:
            </p>

            <ul>
              <li>Telephone numbers</li>
              <li>Message content</li>
              <li>Message timestamps</li>
              <li>Message identifiers</li>
              <li>Delivery information</li>
              <li>Opt-out information</li>
              <li>Technical routing information</li>
              <li>Messaging status information</li>
            </ul>

            <p>
              Our service providers process information subject to
              their contractual, legal, privacy, and security
              obligations.
            </p>

            <h2 className="futuraPTMedium">
              6. Internal Employee Notifications
            </h2>

            <p>
              ADS Sports Complex may send authorized employees SMS
              messages containing operational information required to
              prepare, fulfill, deliver, coordinate, or manage
              customer orders, reservations, or events.
            </p>

            <p>
              These messages may include:
            </p>

            <ul>
              <li>Order numbers</li>
              <li>Order contents</li>
              <li>Order status</li>
              <li>Fulfillment instructions</li>
              <li>Delivery or pickup information</li>
              <li>Reservation details</li>
              <li>Event details</li>
              <li>Customer fulfillment information</li>
            </ul>

            <p>
              Access to this information is intended to be limited to
              employees and service providers who require it for
              legitimate business purposes.
            </p>

            <h2 className="futuraPTMedium">
              7. How We Share Information
            </h2>

            <p>
              We may share information in the circumstances described
              below.
            </p>

            <h3>Service Providers</h3>

            <p>
              We may provide information to vendors and service
              providers that perform services on our behalf, including
              providers of:
            </p>

            <ul>
              <li>Website hosting</li>
              <li>Application hosting</li>
              <li>Cloud infrastructure</li>
              <li>Payment processing</li>
              <li>SMS delivery</li>
              <li>Email delivery</li>
              <li>Authentication</li>
              <li>Cybersecurity</li>
              <li>Customer support</li>
              <li>Order fulfillment</li>
              <li>Analytics</li>
              <li>Reservation or event administration</li>
            </ul>

            <p>
              Service providers are permitted to use information only
              as appropriate to perform services for ADS Sports
              Complex, comply with applicable law, or protect the
              security and integrity of their services.
            </p>

            <h3>Legal and Safety Requirements</h3>

            <p>
              We may disclose information when we reasonably believe
              disclosure is necessary to:
            </p>

            <ul>
              <li>Comply with applicable law</li>
              <li>
                Respond to a lawful subpoena, court order, or
                government request
              </li>
              <li>Enforce our agreements or policies</li>
              <li>Investigate suspected fraud or misconduct</li>
              <li>Protect the security of our systems</li>
              <li>Prevent unauthorized access</li>
              <li>Protect our rights</li>
              <li>
                Protect the rights, safety, or property of our
                customers, employees, or others
              </li>
            </ul>

            <h3>Business Transactions</h3>

            <p>
              If ADS Sports Complex is involved in a merger,
              acquisition, financing, restructuring, sale of assets,
              or similar business transaction, information may be
              disclosed or transferred as part of that transaction,
              subject to applicable law.
            </p>

            <h2 className="futuraPTMedium">
              8. We Do Not Sell SMS Consent Information
            </h2>

            <p>
              ADS Sports Complex does not sell or rent SMS opt-in data
              or SMS consent information.
            </p>

            <p>
              We do not provide SMS consent information to third
              parties for unrelated advertising or promotional
              campaigns.
            </p>

            <p>
              Consent provided to ADS Sports Complex to receive
              transactional or informational text messages applies to
              communications from ADS Sports Complex and does not
              constitute consent to receive marketing messages from
              unrelated third parties.
            </p>

            <h2 className="futuraPTMedium">
              9. Communication Preferences
            </h2>

            <p>
              You may opt out of applicable SMS notifications at any
              time by replying <strong>STOP</strong> to a text message
              from ADS Sports Complex.
            </p>

            <p>
              After your opt-out request has been processed, you may
              receive a final confirmation message.
            </p>

            <p>
              ADS Sports Complex does not currently provide a
              web-based SMS preference-management interface.
            </p>

            <p>
              Opting out of SMS notifications does not necessarily
              affect communications sent through other channels, such
              as email, when those communications are otherwise
              permitted.
            </p>

            <h2 className="futuraPTMedium">
              10. Data Retention
            </h2>

            <p>
              ADS Sports Complex retains personal information for as
              long as reasonably necessary to:
            </p>

            <ul>
              <li>Provide our services</li>
              <li>Fulfill orders</li>
              <li>Administer reservations and events</li>
              <li>Maintain account records</li>
              <li>Maintain transaction records</li>
              <li>
                Document communication preferences and SMS consent
              </li>
              <li>
                Process and document opt-out requests
              </li>
              <li>Resolve disputes</li>
              <li>Enforce agreements and policies</li>
              <li>Meet security requirements</li>
              <li>Detect and prevent fraud</li>
              <li>
                Comply with applicable legal and regulatory
                obligations
              </li>
            </ul>

            <p>
              Retention periods may vary based on the type of
              information and the purpose for which it was collected.
            </p>

            <h2 className="futuraPTMedium">
              11. Information Security
            </h2>

            <p>
              ADS Sports Complex uses reasonable administrative,
              technical, and organizational safeguards designed to
              protect personal information from unauthorized access,
              disclosure, alteration, loss, destruction, or misuse.
            </p>

            <p>
              However, no system, network, or method of electronic
              transmission is completely secure, and we cannot
              guarantee absolute security.
            </p>

            <p>
              You should never provide an ADS Sports Complex one-time
              passcode or multi-factor authentication code to another
              person.
            </p>

            <h2 className="futuraPTMedium">
              12. Children's Privacy
            </h2>

            <p>
              ADS Sports Complex services may include sports,
              recreation, events, reservations, camps, leagues, or
              similar activities that may involve minors.
            </p>

            <p>
              Where required by law, personal information relating to
              a minor should be provided by or with the authorization
              of a parent, legal guardian, or other authorized adult.
            </p>

            <p>
              We do not knowingly collect personal information from
              children in a manner prohibited by applicable law.
            </p>

            <p>
              If you believe information relating to a child has been
              collected improperly, please contact us using the
              information provided below.
            </p>

            <h2 className="futuraPTMedium">
              13. Your Privacy Rights and Choices
            </h2>

            <p>
              Depending on where you live, applicable law may provide
              you with certain rights regarding your personal
              information.
            </p>

            <p>
              These rights may include the ability to request:
            </p>

            <ul>
              <li>Access to personal information</li>
              <li>Correction of inaccurate information</li>
              <li>Deletion of certain personal information</li>
              <li>
                Information about how personal information is used or
                disclosed
              </li>
              <li>Withdrawal of certain consents</li>
              <li>
                Restriction of certain processing activities where
                applicable
              </li>
            </ul>

            <p>
              To submit a privacy request, contact us using the
              information provided in Section 17.
            </p>

            <p>
              We may need to verify your identity before processing
              certain requests.
            </p>

            <h2 className="futuraPTMedium">
              14. Third-Party Services
            </h2>

            <p>
              Our website, applications, payment systems, reservation
              systems, or other services may integrate with or link to
              third-party services.
            </p>

            <p>
              Third parties that operate independently from ADS Sports
              Complex may maintain their own privacy policies and
              practices.
            </p>

            <p>
              ADS Sports Complex is not responsible for the privacy
              practices of independent third parties.
            </p>

            <p>
              We encourage you to review the privacy policies of any
              third-party services you use.
            </p>

            <h2 className="futuraPTMedium">
              15. Cookies and Website Technologies
            </h2>

            <p>
              ADS Sports Complex may use cookies and similar
              technologies on our website to:
            </p>

            <ul>
              <li>Operate website functionality</li>
              <li>Maintain sessions</li>
              <li>Remember preferences</li>
              <li>Improve performance</li>
              <li>Analyze website usage</li>
              <li>Maintain security</li>
              <li>Detect suspicious activity</li>
            </ul>

            <p>
              The specific technologies used may vary depending on the
              services available through our website.
            </p>

            <h2 className="futuraPTMedium">
              16. Changes to This Privacy Policy
            </h2>

            <p>
              ADS Sports Complex may update this Privacy Policy
              periodically to reflect changes in our services,
              technologies, legal requirements, or business practices.
            </p>

            <p>
              When changes are made, we will update the "Last Updated"
              date at the top of this Privacy Policy.
            </p>

            <p>
              If required by law, we will provide additional notice or
              obtain consent before materially changing how previously
              collected personal information is used.
            </p>

            <h2 className="futuraPTMedium">
              17. Contact Us
            </h2>

            <p>
              If you have questions about this Privacy Policy, our
              privacy practices, or the ADS Sports Complex SMS
              messaging program, contact:
            </p>

             <div className="terms-contact">

              <p>
                <strong>ADS Sports Complex, LLC</strong>
              </p>

              <p>
                doing business as{" "}
                <strong>ADS Sports Complex</strong>
              </p>

              <p className="mt-3">
                Address: 10251 E Loop 1604 N
                <br />
                Converse, TX 78109
              </p>

              <p>
                Email:{" "}
                <a href="mailto:tporter@adssportscomplex.com">
                  tporter@adssportscomplex.com
                </a>
              </p>

              <p>
                Phone:{" "}
                <a href="tel:2108599677">
                  210-859-9677
                </a>
              </p>

              <p>
                Website:{" "}
                <a href="https://adssportscomplex.com">
                  https://adssportscomplex.com
                </a>
              </p>

            </div>

          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}

export default PrivacyPolicy;